module.exports = __webpack_public_path__ + "static/img/tencent.daf4aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tencent.png
// module id = 259
// module chunks = 1